import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import type { ProgramTestimonialFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import VideoStory from 'bundles/xddp/components/shared/VideoStory';
import type { StudentStoriesProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/student-experience/StudentVideoStories';

type StudentStoryProps = { storyInfo: ProgramTestimonialFragment };

export const StudentVideoStory = ({ storyInfo }: StudentStoryProps) => {
  return (
    <Grid item xs={12}>
      <VideoStory
        {...storyInfo}
        text={storyInfo.authorTitle}
        entryTitle={storyInfo.authorName || storyInfo.entryTitle}
      />
    </Grid>
  );
};

const StudentVideoStories = ({ studentStories, testimonialsTitle }: StudentStoriesProps) => {
  const stories = studentStories ?? [];
  const validStories: Array<ProgramTestimonialFragment> = stories.filter(
    (storyInfo): storyInfo is ProgramTestimonialFragment => storyInfo !== null
  );
  const numberOfStudentStories = validStories.length;

  if (numberOfStudentStories < 1) {
    return null;
  }

  return (
    <div className="rc-StudentVideoStories">
      {testimonialsTitle && (
        <Typography2 component="h3" data-testid="student-video-stories-title" variant="subtitleMedium">
          {testimonialsTitle}
        </Typography2>
      )}
      <Grid container justifyContent="center">
        {validStories.map((storyInfo) => (
          <StudentVideoStory storyInfo={storyInfo} key={storyInfo.videoEmbedUrl} />
        ))}
      </Grid>
    </div>
  );
};

export default StudentVideoStories;
